export default __webpack_public_path__ + "static/media/la.7a9df475.png";